import { Fragment, type FC, type ReactElement } from 'react';

// import { Button } from '@pp/core/src/components/controls/button/Button';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { useHighflyerGameStateSlice } from '../../../store/slices/highflyerGame/selectors';

import styles from './popupContent.module.css';

export interface BlockingModalContentProps {
  actions?: ReactElement[];
  customTitle?: string;
  inCurtain?: boolean;
  messageComponent?: ReactElement;
  messageData?: string[];
  messageTk?: string;
  titleTk?: string;
  betCode?: number;
}

export const BlockingModalContent: FC<BlockingModalContentProps> = ({
  actions,
  customTitle,
  inCurtain,
  messageComponent,
  messageData,
  messageTk,
  titleTk,
  betCode = '',
}): ReactElement => {
  const modsWithBaseClass = useModifiers(
    styles,
    'popupContent',
    {
      inCurtain,
    },
    { withBaseClass: true }
  );
  const isSBBEnabled = useHighflyerGameStateSlice.getIsSecondBetBoardToggle();

  return (
    <div data-testid="blocking-popup-content" className={modsWithBaseClass}>
      {titleTk ? (
        <div data-testid="blocking-popup-title" className={styles.popupContent__title}>
          <L10nText tk={titleTk} />
          {isSBBEnabled && <span>&nbsp;{betCode}</span>}
        </div>
      ) : null}
      {customTitle ? (
        <div data-testid="blocking-popup-title" className={styles.popupContent__title}>
          {customTitle}
        </div>
      ) : null}
      {messageTk ? (
        <div className={styles.popupContent__message}>
          <L10nText tk={messageTk} dynamicValues={messageData} />
        </div>
      ) : null}
      {messageComponent}
      {actions ? (
        <div data-testid="blocking-popup-buttons" className={styles.popupContent__buttons}>
          {actions.map((action, index) => (
            // <Button
            //   key={action.tk}
            //   tk={action.tk}
            //   variant={action.type}
            //   onClick={action.click}
            //   loading={action.loading}
            //   disabled={action.disabled}
            // />
            <Fragment key={index}>{action}</Fragment>
          ))}
        </div>
      ) : null}
    </div>
  );
};
